<template>
  <section class="upload" align="left" v-viewer="{ title: false ,hidden:()=>{isZoom = false}}">
    <!-- 图片列表 -->
    <div
      v-if="$attrs['file-list'] && $attrs['file-list'].length"
      class="upload-image-list"
    >
      <draggable
        tag="span"
        :list="$attrs['file-list']"
        :disabled="!isDrag || isZoom"
        @end="dragEnd"
      >
        <div
          v-for="(image, index) in $attrs['file-list']" :key="index" style='display:inline-block;'>
          <image-item
            :image="image"
            v-if="!especiallyFileTypeList.includes(image.url.slice(image.url.lastIndexOf('.')))"
          >
            <div class="image-item-actions">
              <span
                v-if="viewer"
                class="el-upload-list__item-preview"
                @click="handlePictureCardPreview(image, index)"
              >
                <i class="el-icon-zoom-in"></i>
              </span>
              <span
                v-if="!disabled"
                class="el-upload-list__item-delete"
                @click="handleRemove(image, index)"
              >
                <i class="el-icon-delete"></i>
              </span>
            </div>
          </image-item>
          <file-item v-else :file="image">
            <div class="file-item-actions">
              <span
                v-if="!disabled"
                class="el-upload-list__item-delete"
                @click="handleRemove(image, index)"
              >
                <i class="el-icon-delete"></i>
              </span>
            </div>
          </file-item>
        </div>
      </draggable>
    </div>
    <data-empty-simple
      v-if="(!$attrs['file-list'] || $attrs['file-list'].length === 0) && disabled"
    >
    </data-empty-simple>

    <!-- 点击上传触发区域 -->
    <uploader
      v-if="!disabled"
      v-bind="$attrs"
      v-on="$listeners"
      :auto-upload="true"
      multiple
      name="files"
      :limitSize="limitSize"
      :fileTypeLimit="fileTypeLimit"
      :class="{
        exced: isExced,
      }"
    ></uploader>

    <!-- 粘贴或者拖放上传 -->
    <uploader-by-paste
      v-if="showPaste && !disabled"
      v-bind="$attrs"
      v-on="$listeners"
    ></uploader-by-paste>

    <!-- 图片预览 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </section>
</template>

<script>
import Draggable from 'vuedraggable';
import ImageItem from '@/components/upload/image-item.vue';
import FileItem from '@/components/upload/file-item.vue';
import Uploader from '@/components/upload/uploader.vue';
import UploaderByPaste from '@/components/upload/uploader-by-paste.vue';

export default {
  name: 'Upload',
  components: {
    ImageItem,
    FileItem,
    Uploader,
    UploaderByPaste,
    Draggable,
  },
  mixins: [],
  props: {
    // 是否可以查看大图
    viewer: {
      type: Boolean,
      default: true,
    },
    // 是否显示粘贴上传
    paste: {
      type: Boolean,
      default: true,
    },
    // 禁用编辑
    disabled: {
      type: Boolean,
      default: false,
    },
    // 限制文件大小 MB
    limitSize: {
      type: Number,
      default: 100,
    },
    // 限制文件类型
    fileTypeLimit: {
      type: String,
      default: '',
    },
    // 限制文件类型
    isDrag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      // 需求展示成文件样式的类型列表
      especiallyFileTypeList: ['.pdf'],
      isZoom: false,
    };
  },
  inheritAttrs: false,
  computed: {
    isExced() {
      const { 'file-list': fileList, limit } = this.$attrs;
      const isExced = fileList.length >= limit;
      return isExced;
    },
    showPaste() {
      if (!this.paste) {
        return false;
      }

      return !this.isExced;
    },
  },
  watch: {
  },
  directives: {},
  filters: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    handleRemove(file, index) {
      const fileList = this.$attrs['file-list'];
      const [deleteItem] = fileList.splice(index, 1);
      this.$emit('update', fileList);
      this.$emit('delete', deleteItem);
    },
    handlePictureCardPreview(file, index) {
      this.isZoom = true;
      setTimeout(() => {
        const viewer = this.$el.$viewer;
        viewer.view(index);
      }, 100);
    },
    dragEnd() {
      const fileList = this.$attrs['file-list'];
      this.$emit('update', fileList);
    },
    getSortList() {
      console.log('this.$attrs[file-list]', this.$attrs['file-list']);
    },
  },
};
</script>

<style lang="scss" scoped>
.exced {
  display: none;
}
.upload-image-list {
  display: inline-block;
}
</style>
